import { PouchDbRepository } from "../../external";
import StorageHelper from "../../helpers/StorageHelper";
const storageHelper = new StorageHelper();

export class ColaboradoresLocalService {
  static database = "int-colaboradores";
  static databaseEmpresa = null;
  static dbLocalRepository;

  static startSincronizacao(empresaId) {
    if (empresaId && !this.dbLocalRepository) {
      this.databaseEmpresa = `${this.database}-${empresaId}`;
      this.dbLocalRepository = new PouchDbRepository(this.databaseEmpresa);
      this.dbLocalRepository.startSync();
    }
  }

  static stopSincronizacao() {
    if (this.dbLocalRepository) {
      this.dbLocalRepository.stopSync(true);
      this.dbLocalRepository = null;
    }
  }

  static async getAll(filtros, opcoes) {
    if (!this.dbLocalRepository) {
      return [];
    }
    return await this.dbLocalRepository.getAll(filtros, opcoes);
  }

  static async deletarDatabase(empresaId) {
    this.startSincronizacao(empresaId);
    await this.dbLocalRepository.deleteDatabase();
    this.dbLocalRepository = null;
    storageHelper.removeLocal(`_pouch_${this.databaseEmpresa}`);
  }
}
